import { IsNotEmpty, IsString } from 'class-validator';

export class AdminLogin {
	@IsNotEmpty()
	@IsString()
	login: string;

	@IsNotEmpty()
	@IsString()
	password: string;
}

export class BasicAuthDto {
	@IsNotEmpty()
	login: string;

	@IsNotEmpty()
	password: string;
}
